import axios from '../base/axios';
import API_KEY from './key';

const GET_COMEDY = 'flixfrenzy/redux/GET_COMEDY';

// eslint-disable-next-line default-param-last
const comedyReducer = (state = [], action) => {
  switch (action.type) {
    case GET_COMEDY:
      return action.payload;
    default:
      return state;
  }
};

export const getComedy = () => (dispatch) => {
  axios.get(`discover/movie?api_key=${API_KEY}&with_genres=35`).then((res) => {
    dispatch({
      type: GET_COMEDY,
      payload: res.data,
    });
  });
};

export default comedyReducer;
